import { Head, useForm, Link } from '@inertiajs/react'
import { FormEvent } from 'react'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { AuthLayout } from '@/components/layouts/AuthLayout'

interface ResetPasswordProps {
  reset_password_token: string
}

export default function ResetPassword({ reset_password_token }: ResetPasswordProps) {
  const { data, setData, put, processing, errors } = useForm({
    user: {
      password: '',
      password_confirmation: '',
      reset_password_token,
    },
  })

  const userErrors = errors as Record<string, string>

  const setUserData = (field: string, value: string) => {
    setData('user', { ...data.user, [field]: value })
  }

  const submit = (e: FormEvent) => {
    e.preventDefault()
    put('/users/password')
  }

  return (
    <AuthLayout>
      <Head title="Nouveau mot de passe - Tessan Community" />

      <div className="text-center mb-8">
        <h1 className="text-3xl font-heading font-bold text-text-primary">Nouveau mot de passe</h1>
        <p className="text-text-secondary mt-2">
          Choisissez un nouveau mot de passe pour votre compte
        </p>
      </div>

      <form onSubmit={submit} className="space-y-6">
        <Input
          label="Nouveau mot de passe"
          type="password"
          value={data.user.password}
          onChange={(e) => setUserData('password', e.target.value)}
          error={userErrors['user.password']}
          required
          autoFocus
          hint="Minimum 8 caractères"
        />

        <Input
          label="Confirmer le mot de passe"
          type="password"
          value={data.user.password_confirmation}
          onChange={(e) => setUserData('password_confirmation', e.target.value)}
          error={userErrors['user.password_confirmation']}
          required
        />

        <Button type="submit" className="w-full" disabled={processing}>
          {processing ? 'Modification...' : 'Modifier mon mot de passe'}
        </Button>
      </form>

      <p className="text-center text-text-secondary mt-6">
        <Link href="/users/sign_in" className="text-tessan-green hover:underline">
          Retour à la connexion
        </Link>
      </p>
    </AuthLayout>
  )
}
